import { useEffect, useState } from "react";
import { api } from "../api";
import {
  Notice,
  Section,
  Spinner,
  msgs,
  num,
  ruMonth,
  topicsStarted,
  useAsync,
} from "../components/common";

/**
 * The directory doubles as search: a query here hits /api/search, which spans
 * people and discussions, because "who knows about X" and "where was X
 * discussed" are the same question asked from two directions.
 */
export function PeopleTab({
  onOpenPerson,
  onOpenThread,
}: {
  onOpenPerson: (id: number) => void;
  onOpenThread: (id: number) => void;
}) {
  const [input, setInput] = useState("");
  const [query, setQuery] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setQuery(input.trim()), 350);
    return () => clearTimeout(t);
  }, [input]);

  const browse = useAsync(
    () => (query.length >= 2 ? Promise.resolve(null) : api.people({ limit: 60 })),
    [query]
  );
  const found = useAsync(
    () => (query.length >= 2 ? api.search(query) : Promise.resolve(null)),
    [query]
  );

  return (
    <>
      <div className="screen-head">
        <div className="rail">3 283 автора</div>
        <h1>Люди</h1>
        <p>Кто здесь есть и кто в чём разбирается</p>
      </div>

      <div className="search">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Имя, компания или тема — например «СДО»"
          autoCorrect="off"
          aria-label="Поиск по людям и обсуждениям"
        />
      </div>

      {(browse.loading || found.loading) && <Spinner />}

      {found.data && (
        <>
          {found.data.mode === "full-text" && (
            <Notice>
              Поиск идёт по ключевым словам. Смысловой включится после этапа эмбеддингов.
            </Notice>
          )}
          {found.data.people.length > 0 && (
            <Section title="Люди">
              {found.data.people.map((p) => (
                <button
                  key={p.tg_user_id}
                  className="row"
                  onClick={() => onOpenPerson(p.tg_user_id)}
                >
                  <div className="row-title">{p.display_name ?? "Без имени"}</div>
                  {p.headline && <div className="row-sub">{p.headline}</div>}
                  <div className="row-meta">
                    <span>{msgs(p.msg_count)}</span>
                    {p.org && (
                      <>
                        <span className="sep">/</span>
                        <span>{p.org}</span>
                      </>
                    )}
                  </div>
                </button>
              ))}
            </Section>
          )}
          {found.data.threads.length > 0 && (
            <Section title="Обсуждения">
              {found.data.threads.map((t) => (
                <button
                  key={t.root_msg_id}
                  className="row"
                  onClick={() => onOpenThread(t.root_msg_id)}
                >
                  <div className="row-title">{t.title}</div>
                  {t.summary && <div className="row-sub">{t.summary}</div>}
                  <div className="row-meta">
                    <span>{msgs(t.msg_count)}</span>
                    {t.author && (
                      <>
                        <span className="sep">/</span>
                        <span>{t.author}</span>
                      </>
                    )}
                  </div>
                </button>
              ))}
            </Section>
          )}
          {found.data.people.length === 0 && found.data.threads.length === 0 && (
            <Notice>Ничего не нашлось по запросу «{found.data.query}».</Notice>
          )}
        </>
      )}

      {browse.data && (
        <Section title={`Самые активные · ${num(browse.data.length)}`}>
          {browse.data.map((p) => (
            <button key={p.tg_user_id} className="row" onClick={() => onOpenPerson(p.tg_user_id)}>
              <div className="row-title">{p.display_name ?? "Без имени"}</div>
              {p.headline && <div className="row-sub">{p.headline}</div>}
              <div className="row-meta">
                <span>{msgs(p.msg_count)}</span>
                <span className="sep">/</span>
                <span>{topicsStarted(p.threads_started)}</span>
                {p.last_seen && (
                  <>
                    <span className="sep">/</span>
                    <span>до {ruMonth(p.last_seen)}</span>
                  </>
                )}
              </div>
            </button>
          ))}
        </Section>
      )}
    </>
  );
}
